import {
  MDBAnimation,
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardOverlay,
  MDBCarousel,
  MDBCarouselItem,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBLightbox,
  MDBLightboxItem,
  MDBRow,
  MDBTypography
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import CountUp from "react-countup";
import { Link } from 'react-router-dom';
import '../App.css';
import CategoriesCarousel from "./category/CategoriesCarousel";
import ContactModal from "./contacts/ContactModal";
import { MiscContext } from "./context/MiscProvider";
import { NavbarContext } from "./context/NavProvider";
import { UserProfileContext } from "./context/UserProfileProvider";
import TestimonialsModal from "./testimonials/TestMonialsModal";
import { useTruncateToggle } from "./utils/Common";
import LinkOpenModal from "./utils/LinkOpenModal";

const HomeContent = ({ openLoginModal, openNavbar }) => {
  const {contactPage, setContactPage } = useContext(MiscContext);
  const { isPricing, pageData } = useContext(NavbarContext);
  const { tokenLoaded ,setIsLoginRequired} = useContext(UserProfileContext);

  const delayOfAnimation = 5000;
  const featureDetailKeys = pageData?.featuresSection && Object.keys(pageData?.featuresSection).filter(
    (key) => key !== 'imageUrl'
  );
  const halfLength = pageData?.featuresSection && Math.ceil(featureDetailKeys.length / 2);
  const leftFeatures = featureDetailKeys && featureDetailKeys.slice(0, halfLength);
  const rightFeatures = featureDetailKeys && featureDetailKeys.slice(halfLength);
  const [testimonialModal, setTestimonialModal] = useState(false);
  const toggleTestimonialModal = () => setTestimonialModal(!testimonialModal);
  const [btnSize, setBtnSize] = useState('lg'); // default to lg
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };


  useEffect(() => {
    const images = document.querySelectorAll('.carousel-image');
    images.forEach(image => {
      image.style.maxHeight = '500px';
      image.style.maxWidth = '500px';
      image.style.objectFit = 'cover';
    });
  }, [pageData]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setBtnSize('sm');
      } else {
        setBtnSize('lg');
      }
    };

    // Set the initial size
    handleResize();

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const featureDetailLeftTop = useTruncateToggle();
  const featureDetailRightTop = useTruncateToggle();
  const featureDetailLeftBottom = useTruncateToggle();
  const featureDetailRightBottom = useTruncateToggle();
  const menuTruncate = useTruncateToggle();


  return (
    <>
     {pageData?.banner?.bannerImageUrl ?
        <header className='text-center img-fluid justify-content-end'>
          <div
            className='p-5 text-center bg-image rounded light mb-1 d-flex header-bg mx-2 responsive-banner'
            style={{
              backgroundImage: `url(${pageData?.banner?.bannerImageUrl})`,
              height: `${pageData?.banner?.height}`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className='mask ' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
              <div className='d-flex p-2 align-items-center h-100 justify-content-center'>
                <MDBRow lg='6' md='6' sm='12' className="d-flex flex-column text-center">
                  {pageData?.banner?.text2?.textValue && <p className='mb-0 text-light'>
                    <h3>{pageData?.banner?.text2?.textValue}</h3>
                  </p>}
                  {pageData?.banner?.text3?.textValue && <figure className='mb-0 text-start'>
                    <MDBAnimation
                      infinite
                      tag='i'
                      animation='zoom-in'
                      style={{ color: 'white' }}
                      start='onLoad'
                      duration={delayOfAnimation}
                    >
                      <figcaption className='blockquote-footer mb-2 text-light text-start'>
                        <cite title='Source Title'>{pageData?.banner?.text3?.textValue}</cite>
                      </figcaption>
                    </MDBAnimation>
                  </figure>}
                  <MDBBtnGroup size={btnSize} className="justify-content-start">
                    <MDBBtn size='lg' className='bg-dark text-white bg-opacity-75' onClick={toggleTestimonialModal}>{pageData?.banner?.feedBackButton?.labelText}</MDBBtn>
                    {pageData?.banner?.bannerButton &&
                      <Link to='/products'>
                        <MDBBtn size='lg' className='bg-warning text-white bg-opacity-75'>{pageData?.banner.bannerButton.labelText}</MDBBtn>
                      </Link>
                    }
                    {pageData?.banner?.createAccountButton && !tokenLoaded &&
                      <MDBBtn size='lg' className='bg-warning text-white bg-opacity-75' onClick={() => setIsLoginRequired(true)}>
                        {pageData?.banner.createAccountButton.labelText}
                      </MDBBtn>
                    }
                    {!tokenLoaded &&
                      <MDBBtn size='lg' className='bg-light text-black' onClick={() => setContactPage(true)}>
                        {tokenLoaded ? pageData?.banner?.contactButton?.labelWhenLoggedIn : pageData?.banner?.contactButton?.labelText}
                      </MDBBtn>
                    }
                  </MDBBtnGroup>
                </MDBRow>
              </div>
            </div>
          </div>
        </header>
        :
        <div className='text-center mb-0 mx-2'>
        <MDBCard className="bg-black text-white" style={{ position: 'relative' }}>
          {/* Background Image */}
          <MDBCardImage
            overlay
            src={pageData?.banner?.headerBG}
            alt='...'
            style={{
              whiteSpace: window.innerWidth <= 768 ? "normal" : "nowrap",
              height: window.innerWidth <= 768 ? pageData?.banner?.headerBGHeightSmallView : pageData?.banner?.headerBGHeight,  // Adjust height for small vs large screens
              objectFit: 'cover',
              width: '100%'
            }}
          />
          {/* Overlay */}
          <MDBCardOverlay
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.6)', // Optional background color for overlay
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <MDBCardBody>
              <MDBRow className='g-0'>
                {/* Left Column with Carousel or Card */}
                <MDBCol lg='6' md='6' sm='12' className="d-flex align-items-center justify-content-start mb-2">
                  {pageData?.banner?.isCarousel ? (
                    <MDBCard className="align-items-center justify-content-start mb-2" style={{ width: '100%', maxWidth: '500px' }}>
                      <MDBCarousel showControls showIndicators fade keyboard className="w-100">
                        {pageData?.carouselItems?.map((item, index) => (
                          <MDBCarouselItem itemId={index + 1} key={index}>
                            <img
                              src={item.url}
                              className='d-block w-100 rounded'
                              alt='...'
                              style={{ height: '100%', objectFit: 'cover' }}
                            />
                          </MDBCarouselItem>
                        ))}
                      </MDBCarousel>
                    </MDBCard>
                  ) : (
                    <MDBRow>
                      <MDBCol className="d-flex align-items-center justify-content-start mb-2">
                        {pageData?.banner?.cardImageUrl && (
                          <MDBCardImage src={pageData?.banner?.cardImageUrl} alt='...' fluid className="rounded" />
                        )}
                      </MDBCol>
      
                      <MDBCol className="d-flex align-items-center justify-content-start">
                        <figure className='text-start mb-0'>
                          <MDBTypography blockquote className="mb-0" style={{ whiteSpace: window.innerWidth <= 768 ? "normal" : "nowrap" }}>
                            <p className="display-5 fw-bold text-capitalize mb-0 text-white">{pageData?.banner?.text2?.textValue}</p>
                          </MDBTypography>
                          <figcaption className='blockquote-footer mb-0 mt-0' style={{ whiteSpace: window.innerWidth <= 768 ? "normal" : "nowrap" }}>
                            <MDBAnimation
                              infinite
                              tag='i'
                              animation='zoom-in'
                              style={{ color: 'white' }}
                              start='onLoad'
                              duration={delayOfAnimation}
                            >
                              <cite title='Source Title' dangerouslySetInnerHTML={{ __html: pageData?.banner?.text3?.textValue }} />
                            </MDBAnimation>
                          </figcaption>
                        </figure>
                      </MDBCol>
                    </MDBRow>
                  )}
                </MDBCol>
      
                {/* Right Column with Buttons */}
                <MDBCol lg='6' md='6' sm='12' className="d-flex flex-column">
                  <figure className='text-center mb-0'>
                    <MDBBtnGroup size={btnSize}>
                      <MDBBtn size='lg' className='bg-dark text-white bg-opacity-75' onClick={toggleTestimonialModal}>
                        {pageData?.banner?.feedBackButton?.labelText}
                      </MDBBtn>
                      {pageData?.banner?.bannerButton && (
                        <Link to='/products'>
                          <MDBBtn size='lg' className='bg-warning text-white bg-opacity-75'>{pageData?.banner.bannerButton.labelText}</MDBBtn>
                        </Link>
                      )}
                      {pageData?.banner?.createAccountButton && !tokenLoaded && (
                        <MDBBtn size='lg' className='bg-warning text-white bg-opacity-75' onClick={() => setIsLoginRequired(true)}>
                          {pageData?.banner.createAccountButton.labelText}
                        </MDBBtn>
                      )}
                      {!tokenLoaded && (
                        <MDBBtn size='lg' className='bg-light text-black' onClick={() => setContactPage(true)}>
                          {tokenLoaded
                            ? pageData?.banner?.contactButton?.labelWhenLoggedIn
                            : pageData?.banner?.contactButton?.labelText}
                        </MDBBtn>
                      )}
                    </MDBBtnGroup>
      
                    {pageData?.banner?.text1?.textValue && (
                      <MDBTypography blockquote className="mb-0" style={{ whiteSpace: window.innerWidth <= 768 ? "normal" : "nowrap" }}>
                        <MDBAnimation
                          infinite
                          tag='i'
                          animation='zoom-in'
                          className='text-warning '
                          start='onLoad'
                          duration={delayOfAnimation}
                        >
                          <figcaption className='blockquote-footer text-warning text-center mt-1'>
                            <cite title='Source Title'>{pageData?.banner.text1.textValue}</cite>
                          </figcaption>
                        </MDBAnimation>
                      </MDBTypography>
                    )}
                  </figure>
      
                  {pageData?.statsSection && (
                    <MDBRow className="text-white mt-auto justify-content-end rounded">
                      {pageData.statsSection?.heading && (
                        <p className="h1 text-capitalize mb-3">{pageData.statsSection.heading}</p>
                      )}
      
      <MDBCard className="mb-2 p-4 text-white rounded" style={{ backgroundColor: '#8B0000' }}>
                        <MDBRow className="d-flex align-items-center justify-content-between">
                          {pageData.statsSection?.items?.map((item, index) => (
                            <MDBCol
                              key={index}
                              className="d-flex flex-column align-items-center text-center"
                              md={Math.floor(12 / pageData.statsSection.items.length)}
                            >
                              <img
                                src={item.iconUrl}
                                style={{ height: '45px', marginBottom: '10px' }}
                                alt="Description"
                              />
                              <h2 className="h1 mb-0">
                                <CountUp end={item.value} duration={5} />
                                <MDBIcon fas icon="plus" className="ms-2 h3 text-warning" />
                              </h2>
                              <p className="mb-0 mt-2">{item.label}</p>
                            </MDBCol>
                          ))}
                        </MDBRow>
                      </MDBCard>
                    </MDBRow>
                  )}
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCardOverlay>
        </MDBCard>
      </div>
      
      }
  
    <MDBContainer className="justify-content-center align-items-center text-center">
     
      {contactPage && <ContactModal />}
      <TestimonialsModal testimonialModal={testimonialModal} toggleTestimonialModal={toggleTestimonialModal} setTestimonialModal={setTestimonialModal} />
      {pageData.promotionSection?.promotionMessageFragments &&
        <figure className='text-center mb-0'>
          <MDBTypography className='lead mb-0 text-center blockquote'>
            {pageData?.promotionSection?.icon && (
              <MDBIcon icon={pageData?.promotionSection?.icon} className='me-2 text-info' />
            )}
            {pageData.promotionSection?.promotionMessageFragments.map((msgFragment, index) => (
              msgFragment.highlight ? (
                <MDBTypography tag='mark' key={index}>{msgFragment.fragmentText}</MDBTypography>
              ) : (
                msgFragment.fragmentText
              )
            ))}
          </MDBTypography>
          <figcaption className='mb-0'>
            <cite title='dewali'>{pageData?.promotionSection?.promotionTeaser}</cite>
          </figcaption>
        </figure>
      }
      {isPricing &&
        <Link to='/' className='m-1'>
          <MDBIcon fas icon="hand-point-left" />
          {tokenLoaded ? ' upgrade or downgrade' : ' Go Back to Subscribe'}
        </Link>
      }
      {featureDetailKeys?.length < 7 ?
        <MDBContainer className='text-center mt-0 rounded bg-white'>
          <section>
            {pageData?.welcomeMessage?.textValue &&
              <h5 className={`fw-bold text-blue-900 ${pageData.welcomeMessage.textSize || 'default-text-size'}`}>

                {pageData.welcomeMessage.textValue}</h5>
            }
            {pageData?.welcomeSubMessage?.textValue &&
              <h6 className="mb-2 text-uppercase text-muted">{pageData.welcomeSubMessage.textValue}</h6>
            }
            <MDBRow className='d-flex align-items-center justify-content-center gx-5'>
              <MDBCol lg='4' md='12'>
                <MDBRow className='mb-2'>
                  {pageData?.featuresSection.featureDetailLeftTop.isCard ?
                    <MDBCard position='top'>

                      <MDBLightbox>
                        <MDBLightboxItem
                          style={{ width: '100%' }}
                          zoomlevel={0.25}
                          src={pageData?.featuresSection.featureDetailLeftTop.image}
                          fullscreenSrc={pageData?.featuresSection.featureDetailLeftTop.image}
                          className="rounded"
                          alt="Feature Image"
                        />
                      </MDBLightbox>

                      <MDBCardBody>
                        <h5 className="card-title fw-bold my-4 text-black text-center">
                          {pageData.featuresSection.featureDetailLeftTop.featureTitle}
                        </h5>
                        <p
                          ref={featureDetailLeftTop.textRef}
                          className={featureDetailLeftTop.isExpanded ? '' : 'truncate'}
                          dangerouslySetInnerHTML={{
                            __html: `
              ${pageData.featuresSection.featureDetailLeftTop.featureDescription}<br>
              ${pageData.featuresSection.featureDetailLeftTop.description2 || ''}
            ` }}
                        ></p>
                        {featureDetailLeftTop.isTruncated && (
                          <MDBBtn size="sm" color="link" onClick={featureDetailLeftTop.toggleExpanded} className="text-lowercase" >
                            {featureDetailLeftTop.isExpanded ? 'Show Less' : 'Show More'}
                          </MDBBtn>
                        )}
                      </MDBCardBody>
                    </MDBCard>
                    :
                    <MDBCard>

                      <MDBCol>
                        {pageData?.featuresSection.featureDetailLeftTop.icon ?
                          <MDBIcon fas icon={pageData?.featuresSection.featureDetailLeftTop.icon} size='3x' className='mt-2' color='warning' />
                          :
                          <img src={pageData?.featuresSection.featureDetailLeftTop.image} alt="Fresh" style={{ height: '100px' }} className="rounded" />
                        }
                        <h5 className="card-title fw-bold my-4 text-black text-center">{pageData?.featuresSection.featureDetailLeftTop.featureTitle}</h5>
                        <p className="text-dark text-start" dangerouslySetInnerHTML={{ __html: pageData?.featuresSection.featureDetailLeftTop.featureDescription }}></p>
                      </MDBCol>
                    </MDBCard>
                  }

                </MDBRow>
                <MDBRow className='mb-2'>
                  {pageData?.featuresSection.featureDetailLeftBottom.isCard ?
                    <MDBCard>


                      <MDBLightbox>
                        <MDBLightboxItem
                          style={{ width: '100%' }}
                          zoomlevel={0.25}
                          src={pageData?.featuresSection.featureDetailLeftBottom.image}
                          fullscreenSrc={pageData?.featuresSection.featureDetailLeftBottom.image}
                          className="rounded"
                          alt="Feature Image"
                        />
                      </MDBLightbox>


                      <MDBCardBody>
                        <h5 className="card-title fw-bold my-2 text-black text-center">
                          {pageData.featuresSection.featureDetailLeftBottom.featureTitle}
                        </h5>
                        <p
                          ref={featureDetailLeftBottom.textRef}
                          className={featureDetailLeftBottom.isExpanded ? '' : 'truncate'}
                          dangerouslySetInnerHTML={{
                            __html: `
              ${pageData.featuresSection.featureDetailLeftBottom.featureDescription}<br>
              ${pageData.featuresSection.featureDetailLeftBottom.description2 || ''}<br>
              ${pageData.featuresSection.featureDetailLeftBottom.description3 || ''}<br>
              ${pageData.featuresSection.featureDetailLeftBottom.description4 || ''}<br>
              ${pageData.featuresSection.featureDetailLeftBottom.description5 || ''}
            ` }}
                        ></p>
                        {featureDetailLeftBottom.isTruncated && (
                          <MDBBtn size="sm" color="link" onClick={featureDetailLeftBottom.toggleExpanded} className="text-lowercase">
                            {featureDetailLeftBottom.isExpanded ? 'Show Less' : 'Show More'}
                          </MDBBtn>
                        )}
                      </MDBCardBody>



                    </MDBCard>
                    :

                    <MDBCard>
                      <MDBCol>
                        {pageData?.featuresSection.featureDetailLeftBottom.icon ?
                          <MDBIcon fas icon={pageData?.featuresSection.featureDetailLeftBottom.icon} size='3x' className='mt-2' style={{ color: '#2b5497' }} />
                          :
                          <img src={pageData?.featuresSection.featureDetailLeftBottom.image} alt="Fresh" style={{ height: '100px' }} className="rounded" />
                        }
                        <h5 className="card-title fw-bold my-4 text-black text-center">{pageData.featuresSection.featureDetailLeftBottom.featureTitle}</h5>
                        <p className="text-dark text-start" dangerouslySetInnerHTML={{ __html: pageData.featuresSection.featureDetailLeftBottom.featureDescription }}></p>
                      </MDBCol>
                    </MDBCard>
                  }
                </MDBRow>
              </MDBCol>
              <MDBCol lg='4' md='12' className='text-center'>
                <MDBCard>
                  <MDBCarousel showControls showIndicators fade keyboard>
                    {pageData?.carouselItems?.map((item, index) => (
                      <MDBCarouselItem itemId={index + 1} key={index}>
                        <img src={item.url} className='d-block w-100 rounded' alt='...' />
                      </MDBCarouselItem>
                    ))}
                  </MDBCarousel>
                </MDBCard>
              </MDBCol>
              <MDBCol lg='4' md='12'>
                <MDBRow className='mb-2'>
                  {pageData?.featuresSection.featureDetailRightTop.isCard ?
                    <MDBCard>

                      <MDBLightbox>
                        <MDBLightboxItem
                          style={{ width: '100%' }}
                          zoomlevel={0.25}
                          src={pageData?.featuresSection.featureDetailRightTop.image}
                          fullscreenSrc={pageData?.featuresSection.featureDetailRightTop.image}
                          className="rounded"
                          alt="Feature Image"
                        />
                      </MDBLightbox>


                      <MDBCardBody>
                        <h5 className="card-title fw-bold my-2 text-black text-center">
                          {pageData.featuresSection.featureDetailRightTop.featureTitle}
                        </h5>
                        <p
                          ref={featureDetailRightTop.textRef}
                          className={featureDetailRightTop.isExpanded ? '' : 'truncate'}
                          dangerouslySetInnerHTML={{
                            __html: `
              ${pageData.featuresSection.featureDetailRightTop.featureDescription}<br>
              ${pageData.featuresSection.featureDetailRightTop.description2 || ''}<br>
              ${pageData.featuresSection.featureDetailRightTop.description3 || ''}<br>
              ${pageData.featuresSection.featureDetailRightTop.description4 || ''}<br>
              ${pageData.featuresSection.featureDetailRightTop.description5 || ''}
            ` }}
                        ></p>
                        {featureDetailRightTop.isTruncated && (
                          <MDBBtn size="sm" color="link" onClick={featureDetailRightTop.toggleExpanded} className="text-lowercase">
                            {featureDetailRightTop.isExpanded ? 'Show Less' : 'Show More'}
                          </MDBBtn>
                        )}
                      </MDBCardBody>


                    </MDBCard> :
                    <MDBCard>
                      <MDBCol>
                        {pageData?.featuresSection.featureDetailRightTop.icon ?
                          <MDBIcon fas icon={pageData?.featuresSection.featureDetailRightTop.icon} size='3x' className='mt-2' color="primary" />
                          :
                          <img src={pageData?.featuresSection.featureDetailRightTop.image} alt="Fresh" style={{ height: '100px' }} className="rounded" />
                        }
                        <h5 className="card-title fw-bold my-4 text-black text-center">{pageData.featuresSection.featureDetailRightTop.featureTitle}</h5>
                        <p className="text-dark text-start" dangerouslySetInnerHTML={{ __html: pageData.featuresSection.featureDetailRightTop.featureDescription }}></p>
                      </MDBCol>
                    </MDBCard>

                  }
                </MDBRow>
                <MDBRow className='mb-2'>
                  {pageData?.featuresSection.featureDetailRightBottom.isCard ?
                    <MDBCard>


                      <MDBLightbox>
                        <MDBLightboxItem
                          style={{ width: '100%' }}
                          zoomlevel={0.25}
                          src={pageData?.featuresSection.featureDetailRightBottom.image}
                          fullscreenSrc={pageData?.featuresSection.featureDetailRightBottom.image}
                          className="rounded"
                          alt="Feature Image"
                        />
                      </MDBLightbox>


                      <MDBCardBody>
                        <h5 className="card-title fw-bold my-2 text-black text-center">
                          {pageData.featuresSection.featureDetailRightBottom.featureTitle}
                        </h5>
                        <p
                          ref={featureDetailRightBottom.textRef}
                          className={featureDetailRightBottom.isExpanded ? '' : 'truncate'}
                          dangerouslySetInnerHTML={{
                            __html: `
              ${pageData.featuresSection.featureDetailRightBottom.featureDescription}<br>
              ${pageData.featuresSection.featureDetailRightBottom.description2 || ''}<br>
              ${pageData.featuresSection.featureDetailRightBottom.description3 || ''}
            ` }}
                        ></p>
                        {featureDetailRightBottom.isTruncated && (
                          <MDBBtn size="sm" color="link" onClick={featureDetailRightBottom.toggleExpanded} className="text-lowercase">
                            {featureDetailRightBottom.isExpanded ? 'Show Less' : 'Show More'}
                          </MDBBtn>
                        )}
                      </MDBCardBody>


                    </MDBCard> :
                    <MDBCard>
                      <MDBCol>
                        {pageData?.featuresSection.featureDetailRightBottom.icon ?
                          <MDBIcon fas icon={pageData?.featuresSection.featureDetailRightBottom.icon} size='3x' className='mt-3' style={{ color: '#469f0f' }} />
                          :
                          <img src={pageData?.featuresSection.featureDetailRightBottom.image} alt="Fresh" style={{ height: '100px' }} className="rounded" />
                        }
                        <h5 className="card-title fw-bold my-4 text-black text-center">{pageData.featuresSection.featureDetailRightBottom.featureTitle}</h5>
                        <p className="text-dark text-start" dangerouslySetInnerHTML={{ __html: pageData.featuresSection.featureDetailRightBottom.featureDescription }}></p>
                      </MDBCol>
                    </MDBCard>}
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </section>
        </MDBContainer>
        :
        <MDBContainer fluid className='text-center mt-0 rounded'>
          <MDBContainer>
            <MDBRow className='d-flex align-items-center justify-content-center gx-5'>
              {leftFeatures?.map((key, index) => {
                const feature = pageData.featuresSection[key];
                return (
                  <MDBCol lg='4' md='12' key={index}>
                    <MDBRow className='mb-2'>
                      {feature.isCard ?

                        <MDBCard position='top'>

                          <MDBLightbox>
                            <MDBLightboxItem
                              style={{ width: '100%' }}
                              zoomlevel={0.25}
                              src={feature.image}
                              fullscreenSrc={feature.image}
                              className="rounded"
                              alt="Feature Image"
                            />
                          </MDBLightbox>

                          <MDBCardBody>
                            <h5 className="card-title fw-bold my-2 text-black text-center">
                              {feature.featureTitle}
                            </h5>
                            <p
                              ref={featureDetailLeftTop.textRef}
                              className={featureDetailLeftTop.isExpanded ? '' : 'truncate'}
                              dangerouslySetInnerHTML={{
                                __html: `${feature.featureDescription}<br>
                                ${feature.description2 || ''}
                                ` }}
                            ></p>
                            {featureDetailLeftTop.isTruncated && (
                              <MDBBtn size="sm" color="link" onClick={featureDetailLeftTop.toggleExpanded} className="text-lowercase">
                                {featureDetailLeftTop.isExpanded ? 'Show Less' : 'Show More'}
                              </MDBBtn>
                            )}
                          </MDBCardBody>
                        </MDBCard>
                        :

                        <MDBCard>
                          <MDBCol >
                            {feature?.icon ? (
                              <MDBIcon fas icon={feature.icon} size='3x' className='mt-2' color='warning' />
                            ) : (

                              <MDBLightbox>
                                <MDBLightboxItem
                                  style={{ height: '100px' }}
                                  zoomlevel={0.25}
                                  src={feature.image}
                                  fullscreenSrc={feature.image}
                                  className="rounded"
                                  alt="Feature Image"
                                />
                              </MDBLightbox>
                            )}
                            <h5 className="card-title fw-bold my-2 text-black text-center">
                              {feature.featureTitle}
                            </h5>
                            <p
                              ref={featureDetailLeftTop.textRef}
                              className={featureDetailLeftTop.isExpanded ? 'text-start' : 'truncate text-start'}
                              dangerouslySetInnerHTML={{
                                __html: `${feature.featureDescription}<br>
                                ${feature.description2 || ''}
                                ` }}
                            ></p>
                            {featureDetailLeftTop.isTruncated && (
                              <MDBBtn size="sm" color="link" onClick={featureDetailLeftTop.toggleExpanded} className="text-lowercase">
                                {featureDetailLeftTop.isExpanded ? 'Show Less' : 'Show More'}
                              </MDBBtn>
                            )}
                          </MDBCol></MDBCard>}

                    </MDBRow>
                  </MDBCol>
                );
              })}
              <MDBCol lg='4' md='12' className='text-center mb-2'>
                <MDBCard>
                  <MDBCarousel showControls showIndicators fade keyboard>
                    {pageData?.carouselItems?.map((item, index) => (
                      <MDBCarouselItem itemId={index + 1} key={index}>
                        <img src={item.url} className='d-block w-100 rounded-5' alt='...' style={{ height: '400px' }} />
                     {item.title &&   <div className="d-block carousel-caption">
                          <MDBBtn className="bg-primary text-black bg-opacity-75" onClick={() => setIsLoginRequired(true)}>
                            <h5 className='text-white' dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                          </MDBBtn>
                        </div>}
                      </MDBCarouselItem>
                    ))}
                  </MDBCarousel>
                </MDBCard>
              </MDBCol>
              {rightFeatures?.map((key, index) => {
                const feature = pageData.featuresSection[key];
                return (
                  <MDBCol lg='4' md='12' key={index} >
                    <MDBRow className='mb-5'>
                      {feature.isCard ?

                        <MDBCard position='top'>

                          <MDBLightbox>
                            <MDBLightboxItem
                              style={{ width: '100%' }}
                              zoomlevel={0.25}
                              src={feature.image}
                              fullscreenSrc={feature.image}
                              className="rounded"
                              alt="Feature Image"
                            />
                          </MDBLightbox>

                          <MDBCardBody>
                            <h5 className="card-title fw-bold my-2 text-black text-center">
                              {feature.featureTitle}
                            </h5>
                            <p
                              ref={featureDetailRightTop.textRef}
                              className={featureDetailRightTop.isExpanded ? '' : 'truncate'}
                              dangerouslySetInnerHTML={{
                                __html: `${feature.featureDescription}<br>
                                ${feature.description2 || ''}
                                ` }}
                            ></p>
                            {featureDetailRightTop.isTruncated && (
                              <MDBBtn size="sm" color="link" onClick={featureDetailRightTop.toggleExpanded} className="text-lowercase">
                                {featureDetailRightTop.isExpanded ? 'Show Less' : 'Show More'}
                              </MDBBtn>
                            )}
                          </MDBCardBody>
                        </MDBCard>
                        :

                        <MDBCard>
                          <MDBCol>
                            {feature?.icon ? (
                              <MDBIcon fas icon={feature.icon} size='3x' className='mt-2' color='warning' />
                            ) : (
                              <MDBLightbox>
                                <MDBLightboxItem
                                  style={{ height: '100px' }}
                                  zoomlevel={0.25}
                                  src={feature.image}
                                  fullscreenSrc={feature.image}
                                  className="rounded"
                                  alt="Feature Image"
                                />
                              </MDBLightbox>
                            )}
                            <h5 className="card-title fw-bold my-2 text-black text-center">{feature?.featureTitle}</h5>
                            <p
                              ref={featureDetailRightTop.textRef}
                              className={featureDetailRightTop.isExpanded ? 'align-items-center justify-content-center mb-0' : 'truncate align-items-center justify-content-center mb-0 text-start'}
                              dangerouslySetInnerHTML={{
                                __html: `${feature.featureDescription}<br>
                                ${feature.description2 || ''}
                                ` }}
                            ></p>
                            {feature.links && (
                              <div className="align-items-center justify-content-center mb-0">
                                {feature.links && (
                                  <div className="text-start">
                                    {feature.links.map((link, index) => (
                                      <LinkOpenModal key={index} url={link.value} label={link.label} isOpen={isOpen} toggleOpen={toggleOpen} setIsOpen={setIsOpen} />
                                    ))}
                                  </div>
                                )}
                              </div>

                            )}
                            {featureDetailRightTop.isTruncated && (
                              <MDBBtn size="sm" color="link" onClick={featureDetailRightTop.toggleExpanded} className="text-lowercase">
                                {featureDetailRightTop.isExpanded ? 'Show Less' : 'Show More'}
                              </MDBBtn>
                            )}
                          </MDBCol>
                        </MDBCard>
                      }
                    </MDBRow>
                  </MDBCol>
                );
              })}
            </MDBRow>
          </MDBContainer>
        </MDBContainer>
      }
      {pageData.middleSection?.map((section, index) => {
        return (
          <MDBContainer key={index} className="mb-2 position-relative justify-content-center text-center">
          {section?.titleSubtext?.textValue && (
            <h3
              className="text-center mb-2 text-capitalize text-warning"
              dangerouslySetInnerHTML={{ __html: section.titleSubtext.textValue }}
            ></h3>
          )}
        
          <MDBRow className="d-flex align-items-center justify-content-center">
            {section.image.orientation === 'left' && (
              <MDBCol lg="6" md="12" className="mb-2 mb-lg-0 pb-2 pb-lg-0 pb-xl-2">
                {section.image.thisVideo ? (
                  <div className="d-flex justify-content-center align-items-center mt-2">
                    <video
                      src={section.image.url || 'https://opengrit.com/images/xtrkldemo'}
                      className="img-thumbnail"
                      alt="..."
                      controls
                      loop
                      autoPlay
                      muted
                      style={{ height: '400px', width: 'auto' }}
                    />
                  </div>
                ) : section.image.isCarousel ? (
                  <MDBCarousel showControls showIndicators fade keyboard>
                    {section.image.urls?.map((url, index) => (
                      <MDBCarouselItem itemId={index + 1} key={index}>
                        <img
                          src={url}
                          className="d-block w-100 rounded-5"
                          alt="..."
                          style={{
                            height: 'auto', // Allow the height to adjust automatically
                            width: window.innerWidth <= 768 ? '100%' : 'auto',
                            objectFit: window.innerWidth <= 768 ? 'contain' : 'cover',
                          }}
                        />
                      </MDBCarouselItem>
                    ))}
                  </MDBCarousel>
                ) : (
                  <MDBLightbox>
                    <MDBLightboxItem
                      style={{ width: '100%' }}
                      zoomlevel={0.25}
                      src={section.image.url || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
                      fullscreenSrc={section.image.url || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
                      className="rounded"
                      alt="Feature Image"
                    />
                  </MDBLightbox>
                )}
              </MDBCol>
            )}
        
            <MDBCol lg="6" md="12" className="lead text-center text-md-start">
              <h3 className="text-center text-black mb-2">{section.titleText.textValue}</h3>
              {section.descriptionPara.map((item, index) => (
                <div key={index}>
                  {item?.heading && <h3>{item.heading.textValue}</h3>}
        
                  <p
                    ref={featureDetailLeftTop.textRef}
                    className={featureDetailLeftTop.isExpanded ? 'text-start' : 'truncate text-start'}
                    dangerouslySetInnerHTML={{
                      __html: `${item.textValue}`,
                    }}
                  ></p>
        
                  {featureDetailLeftTop.isTruncated && (
                    <MDBBtn size="sm" color="link" onClick={featureDetailLeftTop.toggleExpanded} className="text-lowercase">
                      {featureDetailLeftTop.isExpanded ? 'Show Less' : 'Show More'}
                    </MDBBtn>
                  )}
                </div>
              ))}
        
              {section.listedText && (
                <ul className="list-unstyled mb-0 text-start">
                  {section.listedText.map((item, index) => (
                    <li key={index}>
                      <MDBIcon fas icon={item.icon} className="me-2" />
                      {item.textValue}
                    </li>
                  ))}
                </ul>
              )}
            </MDBCol>
        
            {section.image.orientation === 'right' && (
              <MDBCol lg="6" md="12" className="mb-4 mb-lg-0 pb-2 pb-lg-0 pb-xl-2">
                <img
                  width="100%"
                  height="auto"
                  src={section.image.url}
                  alt="Sample"
                  className="img-fluid shadow-3 rounded"
                />
              </MDBCol>
            )}
          </MDBRow>
        </MDBContainer>
        
        );
      })}      
</MDBContainer>
{pageData.crossBannerSection && (
  <section  className="bg-image d-flex text-center mx-1 rounded justify-content-center align-items-center">
    <div
      className="bg-image d-flex text-center mx-1 rounded justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${pageData.crossBannerSection.image.url})`,
        height: window.innerWidth <= 768 ? '250px' : '400px', // Adjust height for different screens
        backgroundSize: 'cover', // Make the entire image visible
        backgroundRepeat: 'no-repeat', // Prevent image repetition
        backgroundPosition: 'center', // Center the image
        width: '100%' // Ensure the width is responsive
      }}
    >
      <div className="mask" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}>
        <div className="d-flex justify-content-center align-items-center h-100">
          <div className="text-white">
            <p className="display-6 mb-1">
              <MDBIcon icon="quote-left" className="fa-xs me-1" aria-hidden="true" />
              {pageData.crossBannerSection.image.caption}
              <MDBIcon icon="quote-right" className="fa-xs mes-1" aria-hidden="true" />
            </p>
            <p className="lead font-italic mb-0">~ {pageData.crossBannerSection.image.figCaption}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
)}


   {pageData?.productContainer &&   <MDBContainer className="mx-auto my-1 px-3">
  {pageData?.productContainer?.sections.map((section, secIndex) => (
    <MDBContainer key={secIndex} className={`${section.titleClass}`}>
      {section.title && <h3 className="text-center mb-4">{section.title}</h3>}
      {section.description && (
        <p className="text-center mb-5">{section.description.text}</p>
      )}

      {/* Rows */}
      {section.rows &&
        section.rows.map((row, rowIndex) => (
          <MDBRow
            key={rowIndex}
            className="justify-content-center align-items-center"
          >
            {/* Columns */}
            {row.columns.map((col, colIndex) => (
              <MDBCol
                key={colIndex}
                lg={col.lg || 4}
                md={col.md || 6}
                sm={12}
                className={`${col.className} mb-4`}
              >
                {col.content && (
                  <>
                    <h4 className={`${col.content.titleClass} text-center`}>
                      {col.content.title}
                    </h4>
                    <p className="lead text-start mt-3">
                      {col.content.paragraph.text}
                    </p>
                    <MDBBtn
                      outline={col.content.button.outline}
                      color={col.content.button.color}
                      rounded={col.content.button.rounded}
                      size={col.content.button.size}
                    >
                      {col.content.button.label}
                    </MDBBtn>
                  </>
                )}

                {col.image && (
                  <MDBCardImage
                    src={col.image.src}
                    className="img-fluid rounded"
                    alt={col.image.alt}
                  />
                )}

                {col.card && (
                  <MDBCard className={col.card.className}>
                    <MDBCardImage
                      src={col.card.image.src}
                      className="card-img-top rounded"
                      alt={col.card.image.alt}
                      style={col.card.image.style}
                    />
                    <MDBCardBody>
                      <h5 className="text-center my-3">{col.card.body.title}</h5>
                    </MDBCardBody>
                  </MDBCard>
                )}
              </MDBCol>
            ))}
          </MDBRow>
        ))}
    </MDBContainer>
  ))}
</MDBContainer> }

    {pageData.statsSection && (
  <section className="text-center justify-content-center align-items-center rounded  mx-1">
    <div>
      {pageData?.statsSection?.image?.type === 'bg' ? (
        // Use background image
        <div
          className="bg-image bg-fixed text-center rounded"
          style={{
            backgroundImage: `url('${pageData.statsSection.image.url}')`,
            height: pageData.statsSection.image.height
          }}
        >
          <div className="mask" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}>
            <MDBRow className="d-flex justify-content-center align-items-center h-100">
              <MDBCol className="text-white text-center ">
                <p className="h1 text-uppercase mb-2">{pageData.statsSection.heading}</p>
                <MDBRow>
                  {pageData.statsSection.items.map((item, index) => (
                    <MDBCol md="4" key={index} className="mb-0">
                      <img src={item.iconUrl} alt={item.label} style={{ width: '50px' }} />
                      <h2 className="h1 text-success">+{item.value}</h2>
                      <p className="mb-md-0">{item.label}</p>
                    </MDBCol>
                  ))}
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </div>
        </div>
      ) : (
        // Use img element
      pageData.statsSection?.image &&  <div className="text-center">
          <img
            src={pageData.statsSection?.image?.url}
            alt=""
            style={{ height: pageData.statsSection.image.height, width: '100%', objectFit: 'cover' }}
          />
        </div> 
      )}
    </div>
  </section>
)}
{pageData?.menu &&
<MDBContainer>
{pageData?.menu &&
      <MDBContainer className="text-center my-1">
        <h3 className="mb-5 text-capitalize">{pageData.menu?.name}</h3>
      

        {pageData.menu?.paragraphs?.map((paragraph, index) => (
        <div key={index} className={menuTruncate.isExpanded ? 'mt-3 text-start' : 'truncate mt-3 text-start'}>
          
          {/* Conditionally render heading if it exists */}
          {paragraph?.heading?.textValue && (
            <h3 
              className='text-capitalize'
              style={{ color: paragraph.heading.textColor || 'inherit' }}
            >
              {paragraph.heading.textValue}
            </h3>
          )}

          {/* Render the textValue for each paragraph */}
          <p
         
            style={{ color: paragraph.textColor || 'inherit' }}
          >
            {paragraph.textValue}
          </p>

        </div>
      ))}

      {pageData.menu.paragraphs.length > 1 && (
        <MDBBtn size="sm" color="link" onClick={menuTruncate.toggleExpanded} className="text-lowercase" type="button">
          {menuTruncate.isExpanded ? 'Show Less' : 'Show More'}
        </MDBBtn>
      )}
  
{ pageData?.menu?.priceList && 
<CategoriesCarousel categories={pageData.menu.priceList} />
}
      </MDBContainer>}
      <MDBContainer className="my-1">
      {pageData?.menu?.images && (
  <MDBLightbox>
    <MDBRow>
      {pageData.menu.images.map((image, index) => (
        <MDBCol lg="4" className="mb-1" key={index}>
          <MDBCard>
            <MDBLightboxItem
              src={image.src}
              alt={image.alt}
              className="w-100 shadow-1-strong rounded"
            />
          </MDBCard>
        </MDBCol>
      ))}
    </MDBRow>
  </MDBLightbox>
)}

      </MDBContainer>
    </MDBContainer> }
    
    </>
  );
};

HomeContent.propTypes = {
  openLoginModal: PropTypes.func,
  openNavbar: PropTypes.func,
};

export default HomeContent;
